import { Box } from '@dealstack/frontend/shared/components/Box/Box';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationCapChart } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Badge, Flex, rem, Text } from '@mantine/core';
import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';

export const CapChartMap = () => {
	const tCapChart = useTranslationCapChart();
	return (
		<div>
			<Text
				component="h6"
				size="B6Bold"
				fw={800}
				style={{ color: '#4F616C', marginBottom: '0.5rem' }}
			>
				Key
			</Text>
			<Box style={{ boxShadow: 'none', padding: '0.5rem', color: '#0E171C' }}>
				<Flex direction="column" gap="0.5rem">
					<CapChartMapBadge iconVariant="triangle" text={tCapChart('map.partnership')} />
					<CapChartMapBadge iconVariant="square" text={tCapChart('map.company')} />
					<CapChartMapBadge iconVariant="oval" text={tCapChart('map.other')} />
					<CapChartMapBadge iconVariant="pentagon" text={tCapChart('map.trusts')} />
					{/*todo: To be added later on*/}
					{/*<CapChartMapBadge iconVariant="triangle-with-circle" text={tCapChart('map.passthrough')} />*/}
				</Flex>
			</Box>
		</div>
	);
};

const CapChartMapBadge = ({
	iconVariant,
	text,
}: {
	iconVariant: PredefinedIcons;
	text: string;
}) => {
	return (
		<Badge
			key={text}
			size="sm"
			variant="filled"
			color="gray.2"
			c="dark.4"
			leftSection={<Icon variant={iconVariant} size="lg" color="black" />}
		>
			<Text fz={rem(12)} lh={rem(12)} fw={500}>
				{text}
			</Text>
		</Badge>
	);
};
